/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiMetricFromJSON, ApiMetricToJSON, } from './ApiMetric';
export function ApiMetricsNameMapFromJSON(json) {
    return ApiMetricsNameMapFromJSONTyped(json, false);
}
export function ApiMetricsNameMapFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metric': !exists(json, 'metric') ? undefined : ApiMetricFromJSON(json['metric']),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
export function ApiMetricsNameMapToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metric': ApiMetricToJSON(value.metric),
        'name': value.name,
    };
}
